import { useEffect } from 'react'
import { ContentStateInterface } from '../../../../../../@types/types'
import { useAppDispatch } from '../../../../../../app/hooks'
import { rentControlReset } from '../../../../../../redux/reducers/rentControl/rentControlFeature'
import { fetchRentControlIfNeeded } from '../../../../../../redux/thunks/valuation/fetchRentControlIfNeeded'

export function useLoadRentControlData(insertionData: ContentStateInterface, enabled: boolean = true) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const city = insertionData.city?.trim()
    if (!enabled || !city) {
      dispatch(rentControlReset())
      return
    }

    dispatch(fetchRentControlIfNeeded(city))
  }, [enabled, insertionData.city, dispatch])
}
